import { isSameDay, isWithinInterval } from 'date-fns'

function blockoutDatesForDate(date, blockoutDates) {
  return blockoutDates.filter(blockoutDate => {
    const { startsAt, endsAt } = blockoutDate.attributes
    const startDate = new Date(startsAt)
    const endDate = new Date(endsAt)
    
    return isWithinInterval(date, { start: startDate, end: endDate }) ||
           isSameDay(date, startDate) ||
           isSameDay(date, endDate)
  })
}

export default blockoutDatesForDate;